module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-11.3717dc63.jpg";